/**
 * Created by FelixFaragau 24/04/2019.
 */

'use strict';

import './page.scss'
import render from './page.html';

import queryString from 'query-string';

import common from 'module/common';

const LOADING = 'LOADING';
const ERROR = 'ERROR';
const READY = 'READY';

const INTERNAL_STATE_INITIAL = 'INITIAL';
const INTERNAL_STATE_PLANS_DOWNLOADED = 'PLANS_DOWNLOADED';
const INTERNAL_STATE_QUOTES_UPLOADED = 'QUOTES_UPLOADED';

const PLANS_ZIP_IDLE = 'IDLE';
const PLANS_ZIP_CHECKING = 'CHECKING';
const PLANS_ZIP_PREPARING = 'PREPARING';
const PLANS_ZIP_READY = 'READY';
const PLANS_ZIP_FAILED = 'FAILED';
const PLANS_ZIP_POLL_INTERVAL_MS = 10000;

import overlay from 'component/overlay';
import prepareFile from 'module/prepareFile';
import FileButton from 'component/file/button';
import Modal from 'component/modal';
import Checkbox from 'component/checkbox';
import FileDragDrop from 'component/file/drag-drop';
import FileList from 'component/file/list';
import filters from 'module/filters';

import _ from "lodash";

export default render({
  filters,
  components: {
    overlay,
    FileButton,
    Modal,
    Checkbox,
    FileDragDrop,
    FileList
  },
  props: ['stage'],
  data() {
    return {
      state: LOADING,
      message: 'Loading Details',
      path: '#/external/externalQuotesPage/',
      errorMessage: null,
      telemetrySessionId: null,
      id: null,
      customerName: null,
      token: null,
      view: null,
      externalQuoteType: null,
      ref: null,
      branch: null,
      branchInfo: {},
      brand: null,
      projectState: {
        state: null,
        date: null
      },
      partialPostcode: null,
      executiveCustomer: false,
      dropDownClosed: true,
      modalActive: false,
      cannotQuoteActive: false,
      reason: null,
      additionalNotes: null,
      notes: [],
      externalReference: null,
      cost: null,
      leadTime: null,
      externalQuote: {
        state: {
          state: null
        },
        internalState: {
          state: null
        },
        files: []
      },
      leadTimeOptions: [
        '1 Day',
        '2 Days',
        '3 Days',
        '4 Days',
        '5 Days',
        '6 Days',
        '1 Week',
        '2 Weeks',
        '3 Weeks',
        '4 Weeks',
        '1 Month',
        '2 Months',
        '3 Months',
        '4 Months',
        '5 Months',
        '6 Months',
      ],
      quoteContacts: [],
      plans: [],
      filesToUpload: [],
      steps: [
        {path: 'projectDetails', label: 'Project Details'},
        {path: 'submission', label: 'Submission'},
        {path: 'overview', label: 'Overview'},
      ],
      reasons: [
        'Not enough details',
        'No Supply in Area',
        'No suitable Product',
        'Request a Call back (to discuss further)'
      ],
      plansZip: {
        state: PLANS_ZIP_IDLE,
        message: null,
        pollTimer: null,
      },
    }
  },
  computed: {
    branchContact() {
      let branchContact = {};
      branchContact.name = this.branchInfo?.contactName ?? 'Unknown';
      branchContact.telephone = this.branchInfo?.telephone ?? 'Unknown';
      branchContact.email = this.branchInfo?.email ?? 'Unknown';

      return branchContact;
    },
    isExecutive() {
      return this.executiveCustomer ? 'Yes' : 'No';
    },
    currentIndex() {
      let stepIndex = 0;
      this.steps.forEach((step, index) => {
        if (step.path === this.currentStep) {
          stepIndex = index;
        }
      });
      return stepIndex;
    },
    landingView() {
      let landingParam = '';

      switch (this.externalQuote.internalState.state) {
        case INTERNAL_STATE_INITIAL:
          landingParam = 'projectDetails';
          break;
        case INTERNAL_STATE_PLANS_DOWNLOADED:
          landingParam = 'submission';
          break;
        case INTERNAL_STATE_QUOTES_UPLOADED:
          landingParam = 'overview';
          break;
      }

      return landingParam;
    },
    disableSubmitButton() {
      return (!this.externalReference && (this.additionalNotes === null || this.additionalNotes.length < 1)) || _.get(this.externalQuote, 'internalState.state') === INTERNAL_STATE_QUOTES_UPLOADED;
    },
    isStaffView() {
      return this.externalQuoteType === 'stoken';
    },
    isSupplierView() {
      return this.isStaffView === false;
    },
    currentStep() {
      return this.$route.params.stage;
    },
    plansPrepared() {
      return this.plans !== null ? this.plans.map((file) => this.prepareFile(file)) : null;
    },
    quotesPrepared() {
      return this.externalQuote.files.length >= 1 ? this.externalQuote.files.map((file) => this.prepareFile(file)) : null;
    },
    hasFiles() {
      return this.filesToUpload.length >= 1;
    },
    isExternalQuoteActive() {
      return this.isSupplierView && ['QUOTED', 'CANNOT_QUOTE'].includes(this.externalQuote.state.state) === false;
    },
    isPlansZipBusy() {
      return this.plansZip.state === PLANS_ZIP_CHECKING;
    },
    isPlansZipReady() {
      return this.plansZip.state === PLANS_ZIP_READY;
    },
    plansZipButtonLabel() {
      switch (this.plansZip.state) {
        case PLANS_ZIP_CHECKING:
          return 'Checking Plans';
        case PLANS_ZIP_PREPARING:
          return 'Check Plans ZIP';
        case PLANS_ZIP_READY:
          return 'Download Plans ZIP';
        default:
          return 'Download All Plans';
      }
    }
  },
  watch: {
    '$route.fullPath'(to, from) {
      this.logTelemetry('navigation.routeChanged', {
        from,
        to,
      });
    }
  },
  mounted() {
    document.title = 'External Quotes Page';
    this.telemetrySessionId = this.createTelemetrySessionId();
    this.logTelemetry('page.mounted');

    this.setTokenAndView();
    this.logTelemetry('page.tokenResolved', {
      view: this.view,
      externalQuoteType: this.externalQuoteType,
      tokenPresent: this.token !== null && this.token !== undefined,
      tokenFingerprint: this.fingerprint(this.token),
      tokenLength: this.token ? String(this.token).length : 0,
    });

    this.logTelemetry('quote.load.requested', {
      view: this.view === 'stoken' ? 'staff' : this.externalQuoteType,
      externalQuoteType: this.externalQuoteType,
    });

    common
      .httpPost('quote')
      .data({
        view: this.isStaffView ? 'staff' : this.externalQuoteType,
        token: this.token,
        action: 'getQuoteForExternalSupplier',
      })
      .then((res) => {
        this.notes = res.data.notes;
        this.plans = res.data.plans;
        this.ref = res.data.ref;
        this.branch = res.data.branch;
        this.brand = res.data.brand;
        this.partialPostcode = res.data.partialPostcode;
        this.executiveCustomer = res.data.executiveCustomer;
        this.companyContacts = res.data.companyContacts;
        this.branchInfo = res.data.branchInfo;

        if (this.view !== 'staff') {
          this.externalQuote = res.data.externalQuote;
        }

        this.projectState = res.data.projectState;
        this.logTelemetry('quote.load.completed', {
          projectRef: this.ref,
          brand: this.brand,
          branch: this.branch,
          partialPostcode: this.partialPostcode,
          executiveCustomer: this.executiveCustomer,
          planCount: this.plans.length,
          noteCount: this.notes.length,
          landingView: this.landingView,
          externalQuoteState: _.get(this.externalQuote, 'state.state', null),
          externalQuoteInternalState: _.get(this.externalQuote, 'internalState.state', null),
          projectState: _.get(this.projectState, 'state', null),
        });
        this.redirect();
        this.setState(READY, null);
      }, (error) => {
        console.log('Error', error);
        this.logTelemetry('quote.load.failed', {
          error: this.errorTelemetry(error),
        });
        this.setState(ERROR);
        this.message = error.data.message;
      });
  },
  beforeDestroy() {
    this.clearPlansZipPoll();
  },
  methods: {
    downloadLink(file, type) {
      return `file.php?a=externalQuote&t=${this.token}&v=${this.externalQuoteType}&type=${type}&file=${file.id}&name=${encodeURIComponent(file.name)}`;
    },
    deleteDropFile(index) {
      this.filesToUpload.splice(index, 1);
    },
    navigate(path) {
      this.logTelemetry('navigation.requested', {
        from: this.$route.fullPath,
        to: path,
      });

      this.$router.push(path, () => {
        this.logTelemetry('navigation.completed', {
          to: path,
          currentRoute: this.$route.fullPath,
        });
      }, (err) => {
        this.logTelemetry('navigation.failed', {
          to: path,
          error: this.errorTelemetry(err),
        });
      });
    },
    reQuoteProject() {
      this.logTelemetry('externalQuote.requote.requested', {
        externalQuoteState: _.get(this.externalQuote, 'state.state', null),
        externalQuoteInternalState: _.get(this.externalQuote, 'internalState.state', null),
      });
      this.setState(LOADING, 'Resetting Quote');

      common
        .httpPost('externalQuote')
        .data({
          action: 'resetExternalQuote',
          view: this.externalQuoteType,
          token: this.token,
        })
        .then((res) => {
          this.externalQuote = res.data.externalQuote;
          this.logTelemetry('externalQuote.requote.completed', {
            externalQuoteState: _.get(this.externalQuote, 'state.state', null),
            externalQuoteInternalState: _.get(this.externalQuote, 'internalState.state', null),
          });
          this.redirect();
          this.setState(READY, null);
        }, (error) => {
          console.log('Error', error);
          this.logTelemetry('externalQuote.requote.failed', {
            error: this.errorTelemetry(error),
          });
          this.setState(ERROR);
          this.message = _.get(error, 'data.message');
          $('.modal.errorModal').modal({show: true});
        });
    },
    submitForm() {
      this.logTelemetry('externalQuote.submit.requested', {
        hasExternalReference: !!this.externalReference,
        hasCost: !!this.cost,
        leadTime: this.leadTime,
        additionalNotesLength: this.additionalNotes ? this.additionalNotes.length : 0,
        fileCount: this.filesToUpload.length,
        fileNames: this.filesToUpload.map(file => file.name),
      });
      this.setState(LOADING, 'Submitting Your Quote');

      common
        .httpPost('externalQuote')
        .data({
          action: 'uploadExternalQuotes',
          view: this.externalQuoteType,
          token: this.token,
          externalReference: this.externalReference,
          cost: this.cost,
          leadTime: this.leadTime,
          additionalNotes: this.additionalNotes,
          files: {
            externalQuotes: this.filesToUpload
          }
        })
        .then((res) => {
          this.resetSubmissionData();

          this.externalQuote = res.data.externalQuote;
          this.notes = res.data.notes;
          this.logTelemetry('externalQuote.submit.completed', {
            externalQuoteState: _.get(this.externalQuote, 'state.state', null),
            externalQuoteInternalState: _.get(this.externalQuote, 'internalState.state', null),
            noteCount: this.notes.length,
          });
          this.redirect();
          this.setState(READY, null);
        }, (error) => {
          console.log('Error', error);
          this.logTelemetry('externalQuote.submit.failed', {
            error: this.errorTelemetry(error),
          });
          this.setState(ERROR);
          this.message = _.get(error, 'data.message', 'An Error Occurred When Uploading Your Quote. Please Try Again');
          $('.modal.errorModal').modal({show: true});
        });
    },
    cannotQuote() {
      this.logTelemetry('externalQuote.cannotQuote.requested', {
        reason: this.reason,
      });
      this.setState(LOADING, 'Setting as Cannot Quote');
      this.close();

      common
        .httpPost('externalQuote')
        .data({
          action: 'markAsCannotQuote',
          view: this.externalQuoteType,
          token: this.token,
          reason: this.reason
        })
        .then((res) => {
          this.externalQuote.state.state = 'CANNOT_QUOTE';
          this.reason = null;
          this.logTelemetry('externalQuote.cannotQuote.completed', {
            externalQuoteState: _.get(this.externalQuote, 'state.state', null),
          });
          this.redirect();
          this.setState(READY, null);
        }, (error) => {
          console.log('Error', error);
          this.logTelemetry('externalQuote.cannotQuote.failed', {
            error: this.errorTelemetry(error),
          });
          this.setState(ERROR);
          this.message = _.get(error, 'data.message');
          $('.modal.errorModal').modal({show: true});
        });
    },
    downloadAllPlans() {
      const href = this.allPlansLink();
      this.logTelemetry('file.downloadAll.clicked', {
        href: this.sanitizeUrl(href),
        projectRef: this.ref,
        planCount: this.plans.length,
      }, { href });

      this.checkPlansZipDownload({showLoading: true});
    },
    checkPlansZipDownload({showLoading = false, fromPoll = false} = {}) {
      if (showLoading) {
        this.setState(LOADING, 'Checking plans download');
      }

      this.setPlansZipState(PLANS_ZIP_CHECKING, fromPoll ? this.plansZip.message : null);

      common
        .httpPost('externalQuote')
        .data({
          action: 'preparePlansZipDownload',
          view: this.externalQuoteType,
          token: this.token,
          queue: fromPoll === false,
        })
        .then((res) => {
          const status = _.get(res, 'data.status', null);

          if (res.data.ready === true) {
            this.clearPlansZipPoll();
            this.setPlansZipState(PLANS_ZIP_READY, 'Plans ZIP is ready. Click the download button to save it.');
            this.setState(READY, null);
            this.logTelemetry('file.downloadAll.ready', {
              projectRef: this.ref,
              fromPoll,
            });
            return;
          }

          if (status === PLANS_ZIP_FAILED) {
            this.clearPlansZipPoll();
            this.setPlansZipState(PLANS_ZIP_FAILED, res.data.message || 'Plans ZIP could not be prepared. Please try again.');
            this.setState(READY, null);
            this.logTelemetry('file.downloadAll.prepare.failed', {
              projectRef: this.ref,
              fromPoll,
              status,
            });
            return;
          }

          this.setPlansZipState(PLANS_ZIP_PREPARING, res.data.message || 'Plans ZIP is being prepared. Please come back later and try again.');
          this.setState(READY, null);
          this.logTelemetry('file.downloadAll.prepare.pending', {
            projectRef: this.ref,
            fromPoll,
            status,
          });
          this.startPlansZipPoll();
        }, (error) => {
          console.log('Error', error);
          this.clearPlansZipPoll();
          this.setPlansZipState(PLANS_ZIP_FAILED, _.get(error, 'data.message', 'Unable to prepare the plans ZIP. Please try again.'));
          this.setState(READY, null);
          this.logTelemetry('file.downloadAll.prepare.failed', {
            error: this.errorTelemetry(error),
          });
        });
    },
    startPlansZipPoll() {
      this.clearPlansZipPoll();
      this.plansZip.pollTimer = window.setTimeout(() => {
        this.checkPlansZipDownload({fromPoll: true});
      }, PLANS_ZIP_POLL_INTERVAL_MS);
    },
    clearPlansZipPoll() {
      if (this.plansZip.pollTimer !== null) {
        window.clearTimeout(this.plansZip.pollTimer);
        this.plansZip.pollTimer = null;
      }
    },
    setPlansZipState(state, message = null) {
      this.plansZip.state = state;
      this.plansZip.message = message;
    },
    downloadPreparedPlansZip() {
      this.clearPlansZipPoll();
      this.setPlansZipState(PLANS_ZIP_READY, 'Your download should start shortly. If it does not, click Download Plans ZIP again.');
      this.logTelemetry('file.downloadAll.downloadRequested', {
        href: this.sanitizeUrl(this.allPlansLink()),
        projectRef: this.ref,
      }, {
        href: this.allPlansLink(),
      });
      this.setPlansDownloaded();
    },
    setPlansDownloaded() {
      common
        .httpPost('externalQuote')
        .data({
          action: 'setInternalState',
          view: this.externalQuoteType,
          token: this.token,
          internalState: INTERNAL_STATE_PLANS_DOWNLOADED
        })
        .then((res) => {
          this.externalQuote = res.data.externalQuote;
          this.logTelemetry('file.downloadAll.stateUpdate.completed', {
            externalQuoteInternalState: _.get(this.externalQuote, 'internalState.state', null),
          });
          this.redirect();
          this.setState(READY, null);
        }, (error) => {
          console.log('Error', error);
          this.logTelemetry('file.downloadAll.stateUpdate.failed', {
            error: this.errorTelemetry(error),
          });
          this.setState(ERROR);
          this.message = _.get(error, 'data.message');
          $('.modal.errorModal').modal({show: true});
        });
    },
    setState(state, message = undefined) {
      this.state = state;
      if (message !== undefined) {
        this.message = message;
      }
    },
    setTokenAndView() {
      let query = queryString.parse(window.location.search);
      let paramKeys = Object.keys(query);

      if (paramKeys.length < 2) {
        this.setState(ERROR);
      }

      let brand = query['brand'];
      let provider = _.filter(paramKeys, elem => elem !== 'brand')[0];
      let token = query[provider];

      if (brand !== 'jewson' || token === null || token === undefined) {
        this.setState(ERROR);
      }

      this.token = token;
      this.view = provider === 'stoken' ? 'staff' : 'externalSupplier';
      this.externalQuoteType = provider;
    },
    allPlansLink() {
      return `file.php?a=externalQuote&t=${this.token}&v=${this.externalQuoteType}&name=${encodeURIComponent(this.ref + ' - Plans.zip')}`;
    },
    toggleDropdown() {
      this.dropDownClosed = !this.dropDownClosed;
    },
    closeDropdown() {
      this.dropDownClosed = true;
    },
    showDropdown() {
      this.dropDownClosed = false;
    },
    close() {
      this.cannotQuoteActive = false;
    },
    redirect() {
      this.logTelemetry('navigation.redirect.requested', {
        from: this.$route.fullPath,
        to: this.landingView,
        externalQuoteInternalState: _.get(this.externalQuote, 'internalState.state', null),
      });
      this.$router.push({path: this.landingView}, () => {
        this.logTelemetry('navigation.redirect.completed', {
          to: this.landingView,
          currentRoute: this.$route.fullPath,
        });
      }, (err) => {
        if (
          err.name !== 'NavigationDuplicated' && err.message &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          this.logTelemetry('navigation.redirect.failed', {
            to: this.landingView,
            error: this.errorTelemetry(err),
          });
          throw err;
        }
        this.logTelemetry('navigation.redirect.completed', {
          to: this.landingView,
          currentRoute: this.$route.fullPath,
          duplicated: true,
        });
      });
    },
    reloadPage() {
      this.logTelemetry('page.reload.clicked');
      this.message = 'Reloading Page';
      this.state = LOADING;
      location.reload()
    },
    resetSubmissionData() {
      this.filesToUpload = [];
      this.additionalNotes = null;
    },
    setReason(reasonToSet) {
      this.reason = reasonToSet;
    },
    recordDownloadClick(file, type) {
      const href = this.downloadLink(file, type);
      this.logTelemetry('file.download.clicked', {
        type,
        projectRef: this.ref,
        fileId: file.id,
        fileName: file.name,
        href: this.sanitizeUrl(href),
        externalQuoteState: _.get(this.externalQuote, 'state.state', null),
        externalQuoteInternalState: _.get(this.externalQuote, 'internalState.state', null),
      }, { href });
    },
    logTelemetry(event, payload = {}, rawPayload = {}) {
      try {
        const telemetryPayload = this.sanitizeTelemetryPayload({
          ...payload,
          telemetrySessionId: this.telemetrySessionId,
          page: 'externalQuotesPage',
          state: this.state,
          currentStep: this.currentStep,
          path: this.path,
          view: this.view,
          externalQuoteType: this.externalQuoteType,
          tokenPresent: this.token !== null && this.token !== undefined,
          tokenFingerprint: this.fingerprint(this.token),
          tokenLength: this.token ? String(this.token).length : 0,
          location: this.locationTelemetry(),
          userAgent: navigator.userAgent,
          viewport: {
            width: window.innerWidth,
            height: window.innerHeight,
          },
        });

        const rawTelemetryPayload = {
          ...payload,
          ...rawPayload,
          telemetrySessionId: this.telemetrySessionId,
          page: 'externalQuotesPage',
          state: this.state,
          currentStep: this.currentStep,
          path: this.path,
          view: this.view,
          externalQuoteType: this.externalQuoteType,
          token: this.token,
          location: this.rawLocationTelemetry(),
          userAgent: navigator.userAgent,
          viewport: {
            width: window.innerWidth,
            height: window.innerHeight,
          },
        };

        common
          .httpPost('supplierTelemetry')
          .data({
            event,
            payload: telemetryPayload,
            rawPayload: rawTelemetryPayload,
          })
          .then(() => {}, () => {});
      } catch (error) {
        console.warn('Supplier telemetry failed', error);
      }
    },
    locationTelemetry() {
      const query = queryString.parse(window.location.search);
      const provider = this.providerFromQuery(query);
      const providerToken = provider !== null ? query[provider] : null;

      return {
        origin: window.location.origin,
        pathname: window.location.pathname,
        hash: window.location.hash,
        queryKeys: Object.keys(query),
        brand: query.brand || null,
        provider,
        providerTokenPresent: providerToken !== null && providerToken !== undefined,
        providerTokenFingerprint: this.fingerprint(providerToken),
        providerTokenLength: providerToken ? String(providerToken).length : 0,
        hrefFingerprint: this.fingerprint(window.location.href),
        searchLength: window.location.search.length,
        referrer: this.sanitizeUrl(document.referrer),
      };
    },
    rawLocationTelemetry() {
      const query = queryString.parse(window.location.search);
      const provider = this.providerFromQuery(query);

      return {
        href: window.location.href,
        origin: window.location.origin,
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
        query,
        queryKeys: Object.keys(query),
        brand: query.brand || null,
        provider,
        providerToken: provider !== null ? query[provider] : null,
        referrer: document.referrer,
      };
    },
    providerFromQuery(query) {
      if (query.v) {
        return query.v;
      }

      return _.filter(Object.keys(query), key => !['brand', 'a', 't', 'type', 'file', 'name', 'legacyRoute'].includes(key))[0] || null;
    },
    sanitizeUrl(url) {
      if (!url) {
        return null;
      }

      try {
        const parsed = new URL(url, window.location.origin);
        const query = queryString.parse(parsed.search);
        const provider = this.providerFromQuery(query);
        const providerToken = provider !== null ? (query[provider] || query.t || query.id) : null;

        return {
          origin: parsed.origin,
          pathname: parsed.pathname,
          hash: parsed.hash,
          queryKeys: Object.keys(query),
          query: this.sanitizeQuery(query),
          brand: query.brand || null,
          provider,
          providerTokenPresent: providerToken !== null && providerToken !== undefined,
          providerTokenFingerprint: this.fingerprint(providerToken),
          providerTokenLength: providerToken ? String(providerToken).length : 0,
          hrefFingerprint: this.fingerprint(url),
          searchLength: parsed.search.length,
        };
      } catch (error) {
        return {
          parseFailed: true,
          hrefFingerprint: this.fingerprint(url),
          length: url.length,
        };
      }
    },
    sanitizeQuery(query) {
      return _.reduce(query, (sanitized, value, key) => {
        sanitized[key] = this.isTokenLikeTelemetryKey(key)
          ? {
            present: value !== null && value !== undefined && value !== '',
            fingerprint: this.fingerprint(value),
            length: value ? String(value).length : 0,
          }
          : value;

        return sanitized;
      }, {});
    },
    sanitizeTelemetryPayload(value, key = null) {
      if (_.isArray(value)) {
        return value.map(item => this.sanitizeTelemetryPayload(item, key));
      }

      if (_.isPlainObject(value)) {
        return _.reduce(value, (sanitized, currentValue, currentKey) => {
          sanitized[currentKey] = this.sanitizeTelemetryPayload(currentValue, currentKey);
          return sanitized;
        }, {});
      }

      if (key !== null && this.isTokenLikeTelemetryKey(key)) {
        return {
          present: value !== null && value !== undefined && value !== '',
          fingerprint: this.fingerprint(value),
          length: value ? String(value).length : 0,
        };
      }

      return value;
    },
    isTokenLikeTelemetryKey(key) {
      if (typeof key !== 'string') {
        return false;
      }

      return ['token', 't', 'id', 'ctoken', 'm', 'b', 's', 'stoken', 'joists', 'roofLights', 'posiJoists', 'roofTrusses', 'aluminiumWindowsAndDoors', 'timberWindowsAndDoors', 'timberWindows', 'pvcuWindowsAndDoors', 'windowsAndDoors', 'landscaping', 'hollowCoreFloors', 'floorFinishes', 'externalRendering', 'artStone', 'bricks', 'acoustics', 'underfloorHeating', 'timberDoors', 'timberFrames', 'airflow', 'ventilation', 'steelLintelsCatnic', 'steelLintelsBirtley', 'blockAndBeam', 'uPvcWindows'].includes(key) || key.toLowerCase().includes('token');
    },
    errorTelemetry(error) {
      const errorData = _.isFunction(error?.get) ? error.get() : {};
      const additionalData = _.get(errorData, 'additionalData', {});

      return this.sanitizeTelemetryPayload({
        name: error?.name || _.get(errorData, 'type', null),
        message: error?.message || _.get(errorData, 'message', null),
        code: error?.code || _.get(errorData, 'code', null),
        type: _.get(errorData, 'type', null),
        response: _.get(additionalData, 'response', null),
        request: {
          method: _.get(additionalData, 'request.method', null),
          url: this.sanitizeUrl(_.get(additionalData, 'request.url', null)),
          query: _.get(additionalData, 'request.query', null),
          data: _.get(additionalData, 'request.data', null),
        },
      });
    },
    fingerprint(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }

      const input = String(value);
      let hash = 0;

      for (let i = 0; i < input.length; i++) {
        hash = ((hash << 5) - hash) + input.charCodeAt(i);
        hash |= 0;
      }

      return Math.abs(hash).toString(16);
    },
    createTelemetrySessionId() {
      return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    },
    prepareFile: prepareFile
  },
});
